import {
  Directive,
  ElementRef,
  Host,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Renderer2,
  SkipSelf,
} from '@angular/core';
import { AbstractControl, ControlContainer, ControlValueAccessor } from '@angular/forms';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[flValidationState]',
})
export class ValidationStateClassDirective implements OnInit, OnDestroy, ControlValueAccessor {
  // tslint:disable-next-line:no-input-rename
  @Input('flValidationState')
  public flValidationState: string | AbstractControl;

  get formControlInput(): string | AbstractControl {
    return this.flValidationState;
  }

  private _control: AbstractControl;
  private readonly _directiveDestruction = new Subject();

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private _parent: ControlContainer,
    private _elementRef: ElementRef,
    private _renderer: Renderer2,
  ) {}
  public writeValue(obj: any): void {}
  public registerOnChange(fn: any): void {}
  public registerOnTouched(fn: any): void {}
  public setDisabledState?(isDisabled: boolean): void {}

  public ngOnInit() {
    if (typeof this.formControlInput === 'string') {
      if (this._parent == null || this._parent.control == null) {
        throw new Error(`
      using flValidationState requires directive to be in context of a form control group.
      `);
      }
      // tslint:disable-next-line: no-non-null-assertion
      this._control = this._parent.control.get(this.formControlInput)!;
      if (this._control == null) {
        throw new Error(`
      flValidationState: No control exists named "${this.formControlInput}" within this control path.
      `);
      }
    } else {
      this._control = this.formControlInput;
    }

    this._control.statusChanges
      .pipe(startWith(this._control.status), takeUntil(this._directiveDestruction))
      .subscribe((status) => {
        const valid = status === 'VALID' || this._control.disabled;
        this.toggleClass('amg-dirty', this._control.dirty);
        this.toggleClass('amg-pristine', this._control.pristine);
        this.toggleClass('amg-valid', valid);
        this.toggleClass('amg-invalid', !valid);
      });
  }

  @HostListener('click', ['$event'])
  public onBlur() {
    this.toggleClass('amg-touched', true);
  }

  private toggleClass(className: string, isAdd: boolean) {
    isAdd
      ? this._renderer.addClass(this._elementRef.nativeElement, className)
      : this._renderer.removeClass(this._elementRef.nativeElement, className);
  }

  public ngOnDestroy() {
    this._directiveDestruction.next();
  }
}
